var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationHelpAndFaqs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9498 2.08675C21.9498 1.48996 21.4463 1 20.833 1H2.11677C1.50349 1 1 1.48996 1 2.08675V16.4687C1 17.0655 1.50349 17.5555 2.11677 17.5555H3.6121C4.22538 17.5555 4.72887 18.0454 4.72887 18.6422V22.433C4.72887 23.0298 5.09229 23.1808 5.53521 22.7645L10.29 18.307C10.7329 17.8907 11.596 17.5518 12.2131 17.5518H20.833C21.4463 17.5518 21.9498 17.0618 21.9498 16.465V2.08675Z",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4933 11.06C12.4793 10.976 12.4793 10.906 12.4793 10.878C12.4793 10.332 12.7173 9.87 13.1793 9.548L13.7813 9.128C14.5933 8.554 15.1813 7.77 15.1813 6.664C15.1813 5.236 14.0613 3.864 11.9893 3.864C9.87528 3.864 8.82528 5.39 8.82528 6.79C8.82528 7.014 8.85328 7.238 8.90928 7.434L10.4913 7.546C10.4353 7.392 10.4073 7.126 10.4073 6.916C10.4073 6.118 10.9533 5.32 11.9893 5.32C13.0113 5.32 13.5013 6.006 13.5013 6.734C13.5013 7.21 13.3053 7.616 12.8433 7.952L12.1993 8.414C11.3873 9.002 11.0653 9.688 11.0653 10.528C11.0653 10.724 11.0793 10.878 11.0933 11.06H12.4933ZM10.7853 13.076C10.7853 13.636 11.2333 14.098 11.8073 14.098C12.3673 14.098 12.8293 13.636 12.8293 13.076C12.8293 12.516 12.3673 12.04 11.8073 12.04C11.2333 12.04 10.7853 12.516 10.7853 13.076Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationHelpAndFaqs);
export default __webpack_public_path__ + "static/media/navigation-help-and-faqs.5572de02e8fb46fe71330fa017f786cc.svg";
export { ForwardRef as ReactComponent };